import { Icon } from "./Icon";
import { openPalette } from "./CommandPalette";

/**
 * THE SEARCH CONTROL — ONE definition (pro web step 7, step 1's F4). It opens the SAME ⌘K palette (`openPalette`), never a
 * second one. 🔴 W117 (his word, 2026-10-01: *"the search workouts, clients etc is needed in the dashboard? … if yes move
 * it … maybe middle of the page horizontally"*): the SHELL draws it, in its top bar, CENTRED, on every page — no page draws
 * its own on its H1 row any more (the Dashboard and Clients did until W117), so it is in the same place wherever you are.
 */
export function SearchControl() {
  return (
    <button type="button" className="shell-search" onClick={openPalette}>
      <Icon name="search" />
      <span className="shell-search-text">Search clients, workouts…</span>
      <kbd className="shell-search-key" aria-hidden="true">⌘K</kbd>
    </button>
  );
}
